if (!customElements.get('made-in')) {
  customElements.define(
    'made-in',
    class MadeIn extends window.BAO.CustomElement {
      setupListeners () {
        super.setupListeners()

        this.modalTriggerEl = document.querySelector(
          '[data-made-in-external-el="modal-trigger"]',
        )

        if (!this.modalTriggerEl) return

        this.handleModalTrigger = this.handleModalTrigger.bind(this)
        this.handleModalClose = this.handleModalClose.bind(this)

        this.listeners.add(
          this.modalTriggerEl,
          'click',
          this.handleModalTrigger,
        )

        this.els['modal-close'].elements.forEach(modalCloseEl => {
          this.listeners.add(modalCloseEl, 'click', this.handleModalClose)
        })
      }

      handleModalTrigger () {
        this.setAttribute('aria-hidden', 'false')
      }

      handleModalClose () {
        this.setAttribute('aria-hidden', 'true')
      }
    },
  )
}
